$(function () {
        $(window).scroll(function(){
            if($(window).width()> 960){
            nl_scroll_to();
            }
        });



    nl_hover_touch_unstick();

    nl_cookie();
    nl_switch_content(".restaurant-menu-inner");
   /* nl_anchor_link();*/
    nl_footer();
    nl_cookie();
});

function getRecaptchaToken(action) {
    return new Promise(function (resolve, reject) {
        grecaptcha.enterprise.ready(function() {
            grecaptcha.enterprise.execute('6LfiyuAqAAAAAEJfFrlJn96OHCNnDQGT0TBjxS_K', { action: action })
                .then(function(token) {resolve(token);})
                .catch(function(error) {reject(error);});
        });
    });
}

$(document).ready(function () {
//close slider-caption
    if ($('#map').length) {
        initMap();
    }

    if($(document).find('[name=gtoken]').length) {
        $.getScript("https://www.google.com/recaptcha/enterprise.js?render=6LfiyuAqAAAAAEJfFrlJn96OHCNnDQGT0TBjxS_K");
    }

    // CONTACT SUBMIT FORM
    $(document).on('click', '#submitAjaxForm', function (e) {
        $('html, body').animate({
            scrollTop: $("#f-form").offset().top - 65
        }, 500);
        e.preventDefault();

        getRecaptchaToken('form')
            .then(function(token) {
                var $form = $("#f-form");
                $form.find('[name=gtoken]').val(token);
                $form.find('[name]').removeClass('error');
                $form.find('.message-successful,.message-error').addClass("hide");
                $.ajax({
                    type: 'POST',
                    data: $form.serialize(),
                    dataType: 'json'
                }).done(function (data) {
                    if (!data.noerror) {
                        $form.find('.message-error').removeClass("hide");
                    } else {
                        $form.find('.message-successful').removeClass("hide");
                        $form[0].reset();
                    }
                    for (var key in data.errors) {
                        if(!data.errors.key) {
                            $form.find('[name="' + key + '"]').addClass('error');
                        }
                    }
                });
            })
            .catch(function (error) {
                console.error('Chyba při získávání reCAPTCHA tokenu:', error);
            });
    });

    // NEWSLETTER
    $("#validElm1, #existsElm1, #saveElm1, #saveAgree1, #fillName1").hide();
    $("#submitNewsletter1").on("click", function (e) {
        e.preventDefault();
        $("#validElm1, #existsElm1, #saveElm1, #saveAgree1, #fillName1").hide();
        var e = $("#emailNewsletter1").val();
        if(e == ''){
            $('#validElm1').show();
            $('#emailNewsletter1').addClass('error')
        }else{
            $('#emailNewsletter1').removeClass('error')
        }
        return $.ajax({
            type: "POST",
            url: "/www/templates/ajax/ajaxNewsletter.php",
            data: {
                emailNewsletter: e,
                lang: $("html").attr("lang")
            },
            dataType: "json"
        }).done(function (e) {
            0 == e.valid && $("#validElm1").show(), 0 == e.exists && $("#existsElm1").show(), 1 == e.save && ($("#saveElm1").show(), setTimeout(function () {
                $("#emailNewsletter1").val(""), $("#saveElm1").hide()
            }, 3e3))
        }), !1
    });

    // ANTISPAM CONTACT
    if ($("#f-form").length) {
        $("#f-form").append('<input name="antispam" value="antispam" type="hidden" />');
    }

    $(document).on("click",".icon-cross",function(e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).closest('.slide-caption').fadeOut(800);
    });
//show more info-rooms and suites
    $(document).on("click",".show-more",function(e) {
        e.preventDefault();
        e.stopPropagation();

        $(this).parent().find('.box-details').slideDown(700);
        $(this).removeClass('show-more').addClass('show-less').text('SHOW LESS');

        $(this).parent().parent().find('.box-details-restaurant').slideDown(700);
        $(this).removeClass('show-more').addClass('show-less').text('SHOW LESS');
    });

    $(document).on("click",".show-less",function(e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).parent().find('.box-details').slideUp(600);
        $(this).removeClass('show-less').addClass('show-more').text('SHOW DETAILS');

        $(this).parent().parent().find('.box-details-restaurant').slideUp(600);
        $(this).removeClass('show-less').addClass('show-more').text('SHOW DETAILS');
    });


//language - choise
    $( ".language .lang-inner" ).click(function(e) {
        e.preventDefault();
        $( ".choose-lang" ).slideToggle( "slow" );
    });

//light galerry
    $(".main-multi-slider").each(function(){
        $(this).lightGallery({
            thumbnail:true,
            download: false,
            animateThumb: false,
            showThumbByDefault: false
        });
    })
// light gallery rooms

/*    $("").each(function(){
        $(this).lightGallery({
            thumbnail:true,
            download: false,
            animateThumb: false,
            showThumbByDefault: false
        });
    })*/
    $(document).ready(function() {
        $("#full-gallery").lightGallery({
            selector: '.box-img'
        });
    });
// light gallery restaurant

    $(".restaurant-slider").each(function(){
        $(this).lightGallery({
            thumbnail:true,
            download: false,
            animateThumb: false,
            showThumbByDefault: false
        });
    })




//back to top

    $(".circle-gtr").on("click", function (e) {
        e.preventDefault(e);
        var section = $(this).parent().next();
        console.log(section);

        $('html, body').animate({
            scrollTop: section.offset().top - 60
        }, 500);
    });


    $(".circle").on("click", function (e) {
        e.preventDefault(e);
        $('html, body').animate({
            scrollTop: 0
        }, 500);
    });

// chose lang
/*
    $('#choose-lang span').add('icon-arrow-down');
    $('#choose-lang').on('click',function(){
        var span = $(this).find("span");
        span.removeClass('icon-arrow-down');
        span.addClass('icon-arrow-top');
    });
*/

    //fixed-bg
    $('.fixed-bg').hide();

    //mobile menu//
    $( ".icon-hamburger" ).click(function() {
        $('.sidebar').animate({
            left:0
        }).addClass('visible');
        $('.fixed-bg').fadeIn(1000);
    })

    //close menu//
    $('.icon-cross').click(function(){
        console.log("clicnuto")
        $('.sidebar').animate({
            left:-310
        })
        $('.fixed-bg').fadeOut(1000)
    })
    $('.fixed-bg').click(function(){
        console.log("clicnuto")
        $('.sidebar').animate({
            left:-310
        })
        $('.fixed-bg').fadeOut(1000)
    })
    $(document).keyup(function(event){
        if(event.which=='27'){
            $('.sidebar').animate({
                left:-310
            })
            $('.fixed-bg').fadeOut(1000)
        }
    });



    function fn_comp_visual() {
        $.fn.beforeImgLoad = function (callback) {
            var img = $(this);

            var wait = setInterval(function(){
                var w = img.width(),
                    h = img.height();

                if (!img.hasClass("lazyload")) {
                    if(w && h){
                        done(w, h);
                    }
                }
            }, 0);

            var onLoad;
            img.on('load', onLoad = function(){
                done(img.width(), img.height());
            });


            var isDone = false;
            function done(){
                if(isDone){
                    return;
                }
                isDone = true;

                clearInterval(wait);
                img.off('load', onLoad);

                callback.apply(this, arguments);
            }
        };
        $.fn.parallax = function () {
            var window_width = $(window).width();

            return this.each(function(i) {
                var $this = $(this);
                function updateParallax(initial, initial_img_height) {
                    var container_height;
                    if (window_width < 960) {
                        return false;
                    } else {
                        container_height = ($this.height() > 0) ? $this.height() : 500;
                    }
                    var $img = $this.children("img").first(),
                        img_height = $img.height(),
                        parallax_dist = img_height - container_height,
                        bottom = $this.offset().top + container_height,
                        top = $this.offset().top,
                        scrollTop = $(window).scrollTop(),
                        windowHeight = window.innerHeight,
                        windowBottom = scrollTop + windowHeight,
                        percentScrolled = (windowBottom - top) / (container_height + windowHeight),
                        parallax = Math.round((parallax_dist * percentScrolled));
                    if (initial) {
                        img_height = initial_img_height,
                            parallax_dist = img_height - container_height,
                            parallax = Math.round((parallax_dist * percentScrolled));
                    }
                    if ((bottom > scrollTop) && (top < (scrollTop + windowHeight))) {
                        $img.css('transform', "translate3D(0," + parallax + "px, 0)");
                    }

                }
                $this.children("img").beforeImgLoad(function(width, height) {
                    updateParallax(true,height);
                    $this.children("img").css("opacity","1");
                });

                $(window).scroll(function() {
                    window_width = $(window).width();
                    updateParallax(false,false);
                });

                $(window).resize(function() {
                    window_width = $(window).width();
                    $this.children("img").css("opacity","1");
                    updateParallax(false,false);
                });
            });
        };


        var $fn = $(".comp_visual"),
            $slider = $fn.find("[data-visual-slider]"),
            $slider_caption = $fn.find("[data-visual-caption]"),
            $slider_autoplay = $slider.data("visual-slider");


        var $autoplay = true;
        if ($slider_autoplay === "0" || $slider_autoplay === "") {
            $autoplay = false;
        }
        if ($slider_caption.children().length > 1) {
            $slider_caption.slick({
                infinite: true,
                speed: 500,
                fade: true,
                cssEase: 'linear',
                arrows: false,
                dots: false,
                asNavFor: $slider,
                adaptiveHeight: true
            });
        } else {
            $slider_caption = false;
        }

        if ($slider.children().length > 1) {
            $slider.slick({
                infinite: true,
                speed: 500,
                fade: true,
                cssEase: 'linear',
                autoplay: $autoplay,
                autoplaySpeed: $slider_autoplay,
                arrows: false,
                pauseOnHover: false,
                asNavFor: $slider_caption,
                dots: false
            });
            $slider.on('beforeChange', function(){
                $(this).find(".slick-active").next().find("img").addClass("lazyload");
            });
            $slider.on('afterChange', function(){
                $(this).find(".slick-active").find("img").addClass("lazyload");
            });
        }
    }
    fn_comp_visual();
    $(".lib--parallax").find("img:not(.lazyload)").parent().parallax();
    $(document).on('lazybeforeunveil', function(e){
        if ($(e.target).parent().hasClass("lib--parallax")) {
            $(e.target).parent().parallax();
        }
    });


    $(".hp-offers.slide").addClass("is-slide").find('.slider').slick({
        infinite: true,
        speed: 1000,
        arrows:true,
        slidesToShow: 3,
        autoplay: true,
        autoplaySpeed: 4000,
        responsive:
            [
                {
                    breakpoint: 960,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 768,
                    settings: "unslick"
                }
            ]
    });
    if($('.slider-multiple-items .product').length <=3) {
        $('.control-panel a').css('display','none');
    }

    $(document).on("click",".special-offers .icon-arrow-left",function(e) {
        e.preventDefault();
            $('.slider-multiple-items').slick('slickPrev');
    });
    $(document).on("click",".special-offers .icon-arrow-right",function(e) {
        e.preventDefault();
            $('.slider-multiple-items').slick('slickNext');
    });



    $('.slider-multiple-items').slick({

        infinite: true,
        speed: 1200,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: false,
        variableWidth: false,
        dots:false,
        autoplay:true,

        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 960,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 360,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 320,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1

                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
        });


    $('.main-multi-slider').slick({
        infinite: true,
        arrows:true,
        speed: 1200,
        slidesToShow: 5,
        slidesToScroll: 4,
        centerMode: false,
        dots:false,
        autoplay:true,
        padding:0,
        draggable:false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    arrows:false
                }
            },
            {
                breakpoint: 400,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 2,
                    arrows:false
                }
            },
            {
                breakpoint: 360,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 2,
                    arrows:false
                }
            },
            {
                breakpoint: 320,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows:false
                }
            }
        ]
    });


    //__RESTAURANT POPUP WINDOW__//
    //open popup
    $('.restaurant-reserve').on('click', function(event){
        event.preventDefault();
        $('.restaurant-reserve-popup').addClass('is-visible');
        $('body').css("height",'100vh');
        $('body').css("overflow","hidden");
    });

    //close popup
    $('.restaurant-reserve-popup').on('click', function(event){
        if( $(event.target).is('.restaurant-reserve-popup-close') || $(event.target).is('.restaurant-reserve-popup') ) {
            event.preventDefault();
            $(this).removeClass('is-visible');
            $('body').removeAttr('style')
        }
    });
    //close popup when clicking the esc keyboard button
    $(document).keyup(function(event){
        if(event.which=='27'){
            $('.restaurant-reserve-popup').removeClass('is-visible');
            $('body').removeAttr('style')
        }
    });


    //__TimePopPicker__//
    $("#reserveTime").datetimepicker({
        datepicker:false,
        format:'H:i'
    });
    $("#reserveTime").prev(".icon").on("click", function () {
        $(this).next(".time").datetimepicker('show');
    });
    $("#reserveDate").datetimepicker({
        timepicker:false,
        format:'d.m.Y'
    });
    $("#reserveDate").prev(".icon").on("click", function () {
        $(this).next(".date").datetimepicker('show');
    });

})

//--- MAIN --- //
//$(function () {
function initMap() {
    var map;
    map = new google.maps.Map(document.getElementById('map'), {
        center: {lat: $('#map').data('lat'), lng: $('#map').data('lng')},
        zoom: 13,
        scrollwheel: false,
        draggable: false
    });
    var marker = new google.maps.Marker({
        position: map.center,
        map: map,
        title: $('#map').data('title')
    });
}

//--- PLUGINS --- //
$(function () {





});

// --- FUNCTIONS CALLS --- //

// --- AFTER PAGE LOAD --- //
$(window).load(function(){
});
